export default __webpack_public_path__ + "static/media/filter.bc9fbfda.svg";